import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import styles from '../../signUp.module.scss';
import { useTranslates } from 'providers/translates';
type Props = {
  isOpen: boolean;
  onClose: () => void;
}

export const ExistingUserPopup: React.FC<Props> = ({  
  isOpen,
  onClose
  
}) => {
  const { translates: t} = useTranslates();
  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle 
        variant="h4" 
        fontWeight={'bold'} 
        className="defaultTitle1"
      >       
        {t?.login?.accountExistsWithEmailTitle || 'Lorem Ipsum'}
      </DialogTitle>
      <DialogContent sx={{ maxHeight: '400px' }}>
        <p className={`${styles.dialogItem} defaultText`}>          
          {t?.login?.accountExistsWithEmailPopUpErrorText || 'Lorem Ipsum'}          
        </p>
      </DialogContent>
      <DialogActions sx={{ padding: '25px' }}>
        <button 
          className="customButton" 
          onClick={onClose}
        >
          Ok
        </button>
      </DialogActions>
    </Dialog>
  );
}
